<template>
  <div class="animated fadeIn">
    <MainChartTable  :set_data=set_data :selectedData=revenue />
  </div>
</template>
<script>
import MainChartTable from '../MainChartTable'
export default {
    name: 'Revenue',
    props:[ 'setData'],
    components:{
        MainChartTable
    },
    data () {
        return {
            set_data:0,
            revenue:'revenues',
        }
    },
    watch :{
        setData(nValue,oValue){
            this.set_data++
            this.revenue='revenues'
        }
    }
}
</script>
